<template>
  <section class="video-recoding">
    <div v-if="!openPreview">
      <div class="head">
        <span class="icon" @click="goBack()">
          <img src="@/assets/images/arrow-w.svg" alt />
        </span>
        <span class="timing">00:00:00</span>
        <!-- <span class="timing" v-if="!isRecordingStarted">00:00:00</span>
        <span class="timing" v-if="isRecordingStarted">00:00:00</span> -->
        <span class="icon" @click="handleSwitchCamera()" :class="{'isDisabled': !isStart}">
          <img src="@/assets/images/ic_camera.svg" alt />
        </span>
      </div>
      <video autoplay>
        <!-- <source src="movie.mp4" type="video/mp4" />
        <source src="movie.ogg" type="video/ogg" />Your browser does not support the video tag.-->
      </video>
      <span class="video-start-btn" @click="startRecording()" v-if="isStart">
        <img src="@/assets/images/small.svg" alt /> Start
      </span>
      <span class="video-start-btn" v-if="!isStart" @click="goToPreview()">
        <img src="@/assets/images/small.svg" alt /> Stop
      </span>
    </div>
    <video-preview :getVideoData="recordedVideo" v-if="openPreview" />
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="@/assets/images/loader.gif" alt="loader" />
    </div>
  </section>
</template>

<script>
import ApiCaller from "@/utils/apicaller";
import constant from "@/utils/constant";
import { SessionHelper, X_AUTH_ID , JWT_TOKEN} from "@/utils/session";
import CustomToaster from "@/components/Common/CustomToaster";
import VideoPreview from "@/components/NewsModule/VideoPreview";
import axios from "axios";

export default {
  name: "VideoRecording",
  components: { VideoPreview },
  computed: {},
  data() {
    return {
      isValidDetail: false,
      toasterData: {},
      loading: false,
      isStart: true,
      video: null,
      counter: 0,
      deviceId: [],
      selected: undefined,
      cameraStreamCstm: null,
      recordedBlobs: [],
      rec: null,
      recordedVideo: "",
      openPreview: false,
      totalTime: null,
      seconds: 0,
      minutes: 0,
      hours: 0,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToPreview() {
      // this.$router.push("/video-preview");
      this.cameraStreamCstm.stop();
      window.clearInterval(this.totalTime)
    },
    add() {
      console.log('===add====')
       this.seconds++;
      // this.secondsOnly++
      if (this.seconds >= 60) {
          this.seconds = 0;
          this.minutes++;
          if (this.minutes >= 60) {
              this.minutes = 0;
              this.hours++;
          }
      }    
      document.getElementsByClassName('timing')[0].innerHTML = (this.hours ? (this.hours > 9 ? this.hours : "0" + this.hours) : "00") + ":" + (this.minutes ? (this.minutes > 9 ? this.minutes : "0" + this.minutes) : "00") + ":" + (this.seconds > 9 ? this.seconds : "0" + this.seconds);
      this.timer();
    },
    timer() {
        this.totalTime = setTimeout(this.add, 1000);
    },
    handleSuccess(stream) {
      if (stream) {
        this.cameraStreamCstm = new MediaRecorder(stream);
        this.cameraStreamCstm.ondataavailable = e => {
          console.log('=e.data=',e.data)
          this.recordedBlobs.push(e.data);
          if (this.cameraStreamCstm.state == "inactive") {
            let blob = new Blob(this.recordedBlobs, {
              type: "video/x-matroska;codecs=avc1,opus"
            });
            console.log('=stop chla==')
            this.uploadImageFile(blob);
            // this.recordedVideo = URL.createObjectURL(blob);
            // if (this.recordedVideo) {
            //   this.openPreview = true;
            //   // this.uploadImageFile(blob);
            // }
          }
        };
        if (
          (this.deviceId && this.deviceId[0] === this.selected) ||
          this.selected === undefined
        ) {
          this.video.style.transform = "scaleX(-1)";
        } else {
          this.video.style.transform = "scaleX(1)";
        }
        this.video.srcObject = stream;
        return navigator.mediaDevices.enumerateDevices();
      }
    },
    gotDevices(mediaDevices) {
      this.deviceId = [];
      mediaDevices.forEach(mediaDevice => {
        if (mediaDevice.kind === "videoinput") {
          console.log("=mediaDevice.deviceId==", mediaDevice.deviceId);
          this.deviceId.push(mediaDevice.deviceId);
        }
      });
    },
    handleSwitchCamera() {
      this.counter++;
      if (this.counter === this.deviceId.length) this.counter = 0;
      this.selected = this.deviceId && this.deviceId[this.counter];
      if (this.cameraStreamCstm) {
        // this.cameraStreamCstm.getTracks().forEach(function(track) {
        //   track.stop();
        // });
        this.cameraStreamCstm = null;
        this.video.srcObject = null;
      }
      this.start();
    },
    async start(constraints) {
      var videoConstraints = {};
      if (this.selected === undefined) {
        videoConstraints.facingMode = "user";
      } else {
        videoConstraints.deviceId = { exact: this.selected };
      }
      var constraints = {
        audio: { echoCancellation: { exact: true } },
        video: videoConstraints
      };
      try {
        await navigator.mediaDevices
          .getUserMedia(constraints)
          .then(this.handleSuccess)
          .then(this.gotDevices);
      } catch (err) {
        this.handleError(err);
      }
    },

    async uploadImageFile(file) {
        await axios.put(constant.FILE_UPLOAD_URL +'binary?fileType=mp3', file, {
          headers: {
            "Content-Type": "application/octet-stream",
            "X-Auth-Id" : SessionHelper.getCookie(X_AUTH_ID),
            "JWT-TOKEN": SessionHelper.getCookie(JWT_TOKEN)
          }
        })
        .then(data => {
          this.loading = false;
          this.recordedVideo = data.data.Data.CdnUrl
          if(this.recordedVideo){
            this.openPreview = true
          }

        })
        .catch(err => {
          this.loading = false;
          console.log("FAILURE", err);
        });
    },
    startRecording() {
      console.log('start')
      this.isStart = !this.isStart;
      this.recordedBlobs = [];
      this.cameraStreamCstm.start();
      this.timer()
      let options = { mimeType: "video/webm;codecs=vp9,opus" };
    }
  },
  closeCamera(stream) {
    stream.getTracks().forEach(function(track) {
      track.stop();
    });
  },
  mounted() {
    __native_money91.checkForPermissionResult = result => {
      if (result.length) {
        alert("Please Allow camera permission");
        JSBridgePlugin.gotToHome();
      } else {
        this.start();
      }
    };
    const _ = ["android.permission.CAMERA", "android.permission.RECORD_AUDIO"];
    try {
      JSBridgePlugin.checkForPermission(
        _,
        true,
        "__native_money91.checkForPermissionResult"
      );
    } catch (err) {
      console.log(err);
      this.start();
    }
    this.video = document.querySelector("video");
  }
};
</script>

<style lang="scss" scoped>
.isDisabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>>